import { render, staticRenderFns } from "./ExpansionRules.vue?vue&type=template&id=4b92eb62&scoped=true"
import script from "./ExpansionRules.vue?vue&type=script&lang=js"
export * from "./ExpansionRules.vue?vue&type=script&lang=js"
import style0 from "./ExpansionRules.vue?vue&type=style&index=0&id=4b92eb62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b92eb62",
  null
  
)

export default component.exports